
import { Dialog } from "@/components/ui/dialog";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
import { TipForm } from "../TipForm";
import { Tip } from "@/types";

interface TipDialogManagerProps {
  isAddOpen: boolean;
  setIsAddOpen: (open: boolean) => void;
  isEditOpen: boolean;
  setIsEditOpen: (open: boolean) => void;
  editingTip: Tip | null;
  formError: string | null;
  onSubmit: (data: { 
    title: string; 
    content: string; 
    status: string; 
    emoji: string;
    universityId: number | null;
  }) => Promise<void>;
}

export function TipDialogManager({
  isAddOpen,
  setIsAddOpen,
  isEditOpen,
  setIsEditOpen,
  editingTip,
  formError,
  onSubmit,
}: TipDialogManagerProps) {
  return (
    <>
      {formError && (
        <Alert variant="destructive" className="mb-4">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>{formError}</AlertDescription>
        </Alert>
      )}

      <Dialog open={isAddOpen} onOpenChange={setIsAddOpen}>
        <TipForm
          onSubmit={onSubmit}
          error={formError}
          mode="add"
        />
      </Dialog>

      <Dialog open={isEditOpen} onOpenChange={setIsEditOpen}>
        <TipForm
          initialTitle={editingTip?.title}
          initialContent={editingTip?.content}
          initialStatus={editingTip?.status}
          initialEmoji={editingTip?.emoji}
          initialUniversityId={editingTip?.university_id}
          onSubmit={onSubmit}
          error={formError}
          mode="edit"
        />
      </Dialog>
    </>
  );
}
